import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'roo-ui/components';
import { Link as RouterLink } from 'react-router-dom';
import { getAppOutOfDate } from 'store/ui/uiSelectors';
import { ROUTER_BASE_NAME } from 'config';

const AppLink = ({ children, to: route, ...rest }) => {
  const appOutOfDate = useSelector(getAppOutOfDate);
  const as = appOutOfDate ? 'a' : RouterLink;
  const href = appOutOfDate ? `${ROUTER_BASE_NAME}${route}` : undefined;
  const to = appOutOfDate ? undefined : route;

  return (
    <Link {...rest} as={as} href={href} to={to}>
      {children}
    </Link>
  );
};

AppLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

AppLink.defaultProps = {
  children: null,
  to: null,
};

export default AppLink;
